export { ComponentLoader } from './component-loader.class';
export { ComponentLoaderFactory } from './component-loader.factory';
export { ContentRef } from './content-ref.class';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/component-loader/index.js
// module id = ./node_modules/ngx-bootstrap/component-loader/index.js
// module chunks = 5